/**
 * Detects the specific better-auth session validation error that causes
 * the dashboard to crash with an infinite loading screen.
 */
export function isBetterAuthSessionError(error: unknown): boolean {
  if (!(error instanceof Error)) return false;
  const msg = error.message ?? '';
  return msg.includes("Cannot read properties of undefined (reading 'payload')");
}
